export default __webpack_public_path__ + "static/media/Zohaib Ali.1ae5ee83.PNG";